/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ url: NonNullable<unknown>, method: NonNullable<unknown>, status: NonNullable<unknown>, args: NonNullable<unknown>, message: NonNullable<unknown> }} Mail_BodyInputs */



/**
* | output |
* | --- |
* | "Request URL: {url} Request method: {method} Status: {status} Arguments: {args} Error: {message}" |
*
* @param {Mail_BodyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_body = /** @type {((inputs: Mail_BodyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_BodyInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Request URL: ${i?.url}
Request method: ${i?.method}
Status: ${i?.status}
Arguments: ${i?.args}

Error: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Request URL: ${i?.url}
Request method: ${i?.method}
Status: ${i?.status}
Arguments: ${i?.args}

Erreur: ${i?.message}`)
});